import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHTML',
  standalone: true
})
export class SafeHTMLPipe implements PipeTransform {
    private readonly sanitizer = inject(DomSanitizer);

  transform(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
